import React, {useEffect} from 'react';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import CropStepper from "./CropStepper/CropStepper";

import "./DashboardMenu/DashboardPreferences";

import {useCookies} from 'react-cookie';

import {nodeExpressBeagleHash} from './BeagleAws/beagle-aws';
import {isMobile} from 'react-device-detect';


//
// import {
//     plantCalculationExample_1,
//     plantCalculationExample_2,
//     plantCalculationExample_3,
//     plantCalculationExample_4,
//     plantCalculationExample_5, plantCatalogExample
// } from "./CropStepper/PlantCatalogExample";


import DashboardLanguageMenu from "./DashboardMenu/DashboardLanguageMenu";
import DashboardLeftMenu from "./DashboardMenu/DashboardLeftMenu";
import DashboardBanner from "./DashboardMenu/DashboardBanner";
import BeagleSettings from "./BeagleSettings/BeagleSettings";
import {
    validateLanguagePreferenceKeyword,
    validateMathPreferenceKeyword
} from "./DashboardMenu/DashboardPreferences";
import BeagleAbout from "./BeagleAbout/BeagleAbout";
import {awsTableOfContentsURL} from "./BeagleAws/beagle-aws";
import BeagleHistoryContainer from "./BeagleHistory/BeagleHistoryContainer";
import DashboardColorTheme from "./DashboardMenu/DashboardColorTheme";
import DashboardSnackbar from "./DashboardMenu/DashboardSnackbar";
import Box from "@material-ui/core/Box";


function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            www.plantnutrition.io
        </Typography>
    );
}

const drawerWidth = isMobile ? 200 : 232;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: (isMobile ? 12 : 24), // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));


export default function PlantCalcDashboard(props) {
    const classes = useStyles();
    const [dashboardDrawerIsOpen, setDashboardDrawerIsOpen] = React.useState(!isMobile);
    const handleDrawerOpen = () => {
        setDashboardDrawerIsOpen(true);
    };
    const handleDrawerClose = () => {
        setDashboardDrawerIsOpen(false);
    };


    const [cookies, setCookie] = useCookies(['langpref', 'mathpref']);
    const [beagleLanguagePreference, setBeagleLanguagePreference] = React.useState(initBeagleLanguagePreference());
    const [beagleMathPreference, setBeagleMathPreference] = React.useState(getCookieMathPreference());
    const [dashboardPageIndex, setDashboardPageIndex] = React.useState(1);

    const [awsCropDatabase, setAwsCropDatabase] = React.useState({"crops": undefined, "awsStatus": "init"});
    const [awsNetworkCounter, setAwsNetworkCounter] = React.useState(0);

    useEffect(() => {
        let bh = awsNetworkCounter > 2 ? '' : nodeExpressBeagleHash;
        fetch(awsTableOfContentsURL,
            {
                method: 'GET',
                headers: {
                    // 'beagle': bh,
                    'x-api-key': bh,
                    'content-type': 'application/json',
                }
            },
        )
            .then(res => res.json())
            .then(data => {
                console.info(data);
                setAwsCropDatabase({...data, "awsStatus": "finished"});
                setAwsNetworkCounter(awsNetworkCounter + 1)
            })
            .catch(() => {
                setAwsCropDatabase({"crops": undefined, "awsStatus": "unavailable"});
                setAwsNetworkCounter(-1);
            });
        // eslint-disable-next-line
    }, []);  // Pass empty array to only run once on mount.


    //USER PREFERENCE - Language
    function handleChangeLangPref(newPref) {
        newPref = validateLanguagePreferenceKeyword(newPref);
        // console.log('handleChangeLangPref:' + newPref);
        setCookieLanguagePreference(newPref);
        setBeagleLanguagePreference(newPref);
    }

    //USER PREFERENCE - Math
    const handleBeagleMathPreference = (event, pref) => {
        const newPref = validateMathPreferenceKeyword(pref);
        // console.log('handleBeagleMathPreference:' + newPref);
        setBeagleMathPreference(newPref);
        setCookieMathPreference(newPref);
    };


    //USER PREFERENCE - Navigation
    const handleDashboardPageIndex = (event, index) => {
        setDashboardPageIndex(index);
    };

    function setCookieLanguagePreference(pref) {
        pref = validateLanguagePreferenceKeyword(pref);
        setCookie('langpref', pref, {path: '/', maxAge: 86400 * 7});
    }

    function setCookieMathPreference(pref) {
        pref = validateMathPreferenceKeyword(pref);
        setCookie('mathpref', pref, {path: '/', maxAge: 86400 * 7});
    }

    function initBeagleLanguagePreference() {
        let pref = getCookieLanguagePreference();
        setCookie('langpref', pref, {path: '/', maxAge: 86400 * 7});
        return pref;
    }

    function getCookieLanguagePreference() {
        const cookieLanguagePref = cookies['langpref'];
        return validateLanguagePreferenceKeyword(cookieLanguagePref);
    }

    function getCookieMathPreference() {
        const cookieMathPref = cookies['mathpref'];
        return validateMathPreferenceKeyword(cookieMathPref);
    }

    //History - Blank.
    const [beagleCalculatorHistory, setBeagleCalculatorHistory] = React.useState({
        history: []
    });

    const appendBeagleCalculatorHistory = (newBeagleCropCalculation) => {

        //ADD TO END OF ARRAY:
        // setBeagleCalculatorHistory(beagleCalculatorHistory => ({...beagleCalculatorHistory, history: [...beagleCalculatorHistory.history, newBeagleCropCalculation]}));

        //ADD TO BEGINNING OF ARRAY:
        setBeagleCalculatorHistory(beagleCalculatorHistory => ({
            ...beagleCalculatorHistory,
            history: [newBeagleCropCalculation, ...beagleCalculatorHistory.history]
        }));

        // console.log('===== setBeagleCalculatorHistory = ' + newBeagleCropCalculation);
    };


    const removeBeagleCalculatorHistory = (oldBeagleCropCalculation) => {

        let newStuff = beagleCalculatorHistory.history.filter((x) => (x !== oldBeagleCropCalculation));
        setBeagleCalculatorHistory({
            history: newStuff
        });

    }


    return (
        <div className={classes.root}>
            <CssBaseline/>
            <AppBar position="absolute" className={clsx(classes.appBar, dashboardDrawerIsOpen && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, dashboardDrawerIsOpen && classes.menuButtonHidden)}
                    >
                        <MenuIcon/>
                    </IconButton>
                    <DashboardBanner
                        beagleLanguagePreference={beagleLanguagePreference}
                    />
                    <DashboardLanguageMenu
                        beagleLanguagePreference={beagleLanguagePreference}
                        handleChangeLangPref={handleChangeLangPref}
                    />
                    <DashboardColorTheme
                        beagleTheme={props.beagleTheme}
                        toggleBeagleTheme={props.toggleBeagleTheme}
                    />
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !dashboardDrawerIsOpen && classes.drawerPaperClose),
                }}
                open={dashboardDrawerIsOpen}
            >
                <div className={classes.toolbarIcon}>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeftIcon/>
                    </IconButton>
                </div>
                <Divider/>

                <List>
                    <DashboardLeftMenu
                        beagleLanguagePreference={beagleLanguagePreference}
                        beagleMathPreference={beagleMathPreference}
                        handleDashboardPageIndex={handleDashboardPageIndex}
                        dashboardPageIndex={dashboardPageIndex}
                    />
                </List>

                <Divider/>

            </Drawer>
            <main className={classes.content}>
                <div className={classes.appBarSpacer}/>
                <Container maxWidth="lg" className={classes.container}>
                    <Grid container spacing={3}>

                        {dashboardPageIndex !== 1 ? ('') :
                            (
                                <Grid item xs={12} md={12} lg={12}>
                                    <Paper className={classes.paper}>
                                        <CropStepper
                                            beagleLanguagePreference={beagleLanguagePreference}
                                            beagleMathPreference={beagleMathPreference}
                                            appendBeagleCalculatorHistory={appendBeagleCalculatorHistory}
                                            awsCropDatabase={awsCropDatabase}
                                        />
                                    </Paper>
                                </Grid>
                            )}

                        {dashboardPageIndex !== 1 ? ('') :
                            (

                                <BeagleHistoryContainer
                                    beagleLanguagePreference={beagleLanguagePreference}
                                    beagleCalculatorHistory={beagleCalculatorHistory}
                                    removeBeagleCalculatorHistory={removeBeagleCalculatorHistory}
                                />
                            )}

                        {dashboardPageIndex !== 2 ? ('') :
                            (
                                <BeagleSettings
                                    beagleLanguagePreference={beagleLanguagePreference}
                                    beagleMathPreference={beagleMathPreference}
                                    handleBeagleMathPreference={handleBeagleMathPreference}
                                />
                            )}

                        {dashboardPageIndex !== 3 ? ('') :
                            (
                                <BeagleAbout
                                    beagleLanguagePreference={beagleLanguagePreference}
                                />
                            )}

                    </Grid>

                    {dashboardPageIndex === 3 ? ('') :
                        (
                            <Box pt={4}>
                                <Copyright/>
                            </Box>
                        )}

                    <DashboardSnackbar
                        beagleLanguagePreference={beagleLanguagePreference}
                        awsNetworkCounter={awsNetworkCounter}
                    />

                    {/*<h2>awsNetworkCounter={awsNetworkCounter}</h2>*/}

                </Container>
            </main>
        </div>
    );
}
